/*
 *
 * LanguageProvider actions
 *
 */

import {
  CHANGE_LANGUAGE,
  LOADING_LANGUAGE,
  LANGUAGE_LOADED,
  LOAD_UPPTACKA,
  LANGUAGE_ERROR,
  COMMON_LOADED,
  LOADING_APPLICATION_SETTINGS,
  LOADING_TRANSLATIONS,
  LOADING_LOCALE,
  LOADING_DEXF_SETTINGS,
  LOADING_DATA_PROVIDER_SETTINGS,
  GLOBAL_COMMON_LOADED,
  LOADING_PRODUCT_SERVICE,
} from './constants';

export function changeLanguage(country, language) {
  return {
    type: CHANGE_LANGUAGE,
    country,
    language,
  };
}

export function loadingLanguage(loading) {
  return {
    type: LOADING_LANGUAGE,
    loading,
  };
}

export function loadingUpptacka() {
  return {
    type: LOAD_UPPTACKA
  };
}

export function languageLoaded(country, language, messages) {
  if(country === 'lv' && language === 'et') {
    language = 'lv';
  }
  return {
    type: LANGUAGE_LOADED,
    country,
    language,
    messages,
  };
}

export function loadingError(error) {
  return {
    type: LANGUAGE_ERROR,
    error,
  };
}

export function commonLoaded(common) {
  return {
    type: COMMON_LOADED,
    common,
  };
}

export function commonGlobalLoaded(globalCommon, common) {
  return {
    type: GLOBAL_COMMON_LOADED,
    globalCommon,
    common
  };
}

export function loadingApplicationSettings(applicationSettings) {
  return {
    type: LOADING_APPLICATION_SETTINGS,
    applicationSettings
  };
}

export function loadingProductService(productService) {
  return {
    type: LOADING_PRODUCT_SERVICE,
    productService
  };
}

export function loadingTranslations(translations) {
  return {
    type: LOADING_TRANSLATIONS,
    translations
  };
}

export function loadingLocale(country, language) {
  return {
    type: LOADING_LOCALE,
    country,
    language,
  };
}

export function loadingDexfSettings(country, language) {
  return {
    type: LOADING_DEXF_SETTINGS,
    country,
    language,
  };
}

export function loadingDataProviderSettings(country, language) {
  return {
    type: LOADING_DATA_PROVIDER_SETTINGS,
    country,
    language,
  };
}
